export default __webpack_public_path__ + "static/media/helpuser.068fe7bb.png";